import { isMobileOrTabletViewer, isAndroidViewer } from "services/user-agent-service";

const fetchUserAgent = () => {
  return typeof document !== "undefined" && typeof navigator !== "undefined" ? navigator.userAgent : "";
};

export const isAndroid = userAgentParam => {
  const userAgent = userAgentParam || fetchUserAgent();
  return isAndroidViewer(userAgent);
};

export const isMobile = userAgentParam => {
  const userAgent = userAgentParam || fetchUserAgent();
  return isMobileOrTabletViewer(userAgent);
};
